import {ApolloQueryResult} from 'apollo-client';

import {apolloClientNoCache} from '../../../../apolloClient';
import {
  BucketedRunsDeltaQueryInternalIdWithoutRunInfoDocument,
  BucketedRunsDeltaQueryInternalIdWithoutRunInfoQuery,
  BucketedRunsDeltaQueryInternalIdWithoutRunInfoQueryVariables,
  BucketedRunsDeltaQueryWithoutRunInfoDocument,
  BucketedRunsDeltaQueryWithoutRunInfoQuery,
  BucketedRunsDeltaQueryWithoutRunInfoQueryVariables,
  GroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoDocument,
  GroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoQuery,
  GroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoQueryVariables,
  GroupedBucketedRunsDeltaQueryWithoutRunInfoDocument,
  GroupedBucketedRunsDeltaQueryWithoutRunInfoQuery,
  GroupedBucketedRunsDeltaQueryWithoutRunInfoQueryVariables,
} from '../../../../generated/graphql';
import {propagateErrorsContext} from '../../../../util/errors';
import {QueryVars, queryVars} from './queryVars';
import {BucketedQueryPromise} from './types';

export function doBucketedApiQuery(
  vars: ReturnType<typeof queryVars>,
  currentRuns: string[],
  lastUpdated: string
): BucketedQueryPromise {
  return apolloClientNoCache.query<
    BucketedRunsDeltaQueryWithoutRunInfoQuery,
    BucketedRunsDeltaQueryWithoutRunInfoQueryVariables
  >({
    context: propagateErrorsContext(),
    query: BucketedRunsDeltaQueryWithoutRunInfoDocument,
    fetchPolicy: 'no-cache',
    variables: {
      ...vars,
      currentRuns,
      lastUpdated,
    },
  });
}

export function doBucketedApiQueryByInternalId(
  vars: QueryVars,
  currentRuns: string[],
  lastUpdated: string
): BucketedQueryPromise {
  return apolloClientNoCache.query<
    BucketedRunsDeltaQueryInternalIdWithoutRunInfoQuery,
    BucketedRunsDeltaQueryInternalIdWithoutRunInfoQueryVariables
  >({
    context: propagateErrorsContext(),
    query: BucketedRunsDeltaQueryInternalIdWithoutRunInfoDocument,
    fetchPolicy: 'no-cache',
    variables: {
      ...vars,
      currentRuns,
      lastUpdated,
    },
  });
}

export type GroupedBucketedQueryPromise = Promise<
  ApolloQueryResult<GroupedBucketedRunsDeltaQueryWithoutRunInfoQuery>
>;

export function doGroupedBucketedApiQuery(
  vars: QueryVars,
  currentRuns: string[],
  lastUpdated: string
): GroupedBucketedQueryPromise {
  return apolloClientNoCache.query<
    GroupedBucketedRunsDeltaQueryWithoutRunInfoQuery,
    GroupedBucketedRunsDeltaQueryWithoutRunInfoQueryVariables
  >({
    context: propagateErrorsContext(),
    query: GroupedBucketedRunsDeltaQueryWithoutRunInfoDocument,
    fetchPolicy: 'no-cache',
    variables: {
      ...vars,
      currentRuns,
      lastUpdated,
    },
  });
}

export function doGroupedBucketedApiQueryByInternalId(
  vars: ReturnType<typeof queryVars>,
  currentRuns: string[],
  lastUpdated: string
): GroupedBucketedQueryPromise {
  return apolloClientNoCache.query<
    GroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoQuery,
    GroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoQueryVariables
  >({
    context: propagateErrorsContext(),
    query: GroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoDocument,
    fetchPolicy: 'no-cache',
    variables: {
      ...vars,
      currentRuns,
      lastUpdated,
    },
  });
}
